module.exports = __webpack_public_path__ + "static/media/Picture taken from Cathedral Bell Tower c. 1985 (Bryan Porter).2bb012d9.jpg";